import React from 'react'
import { ChevronDown } from 'react-feather'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Dropdown from 'react-dropdown'

const Sorter = ({query = {}, onChange, options}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [defaultValue, setDefaultValue] = React.useState(0)

  const handleChange = (e) => {
    if(e){
      const { value } = e
      let selectedSorter = options.find(o => o.value === value)

      // Old handler
      if (e.target) selectedSorter = options[e.target.value]

      // Side effect
      onChange(selectedSorter)
    }
  }

  React.useEffect(() => {
    const {
      date,
      sort_by_title,
      name
    } = query

    let key = 'date'
    let value = 'oldest'

    if(date && options && options.length > 0){
      if(date === 'desc'){
        value = 'newest'
      }
    }

    if(name && options && options.length > 0){
      key = 'name'
      if(name === 'asc'){
        value = 'az'
      }
      if(name === 'desc'){
        value = 'za'
      }
    }

    if(sort_by_title && options && options.length > 0){
      key = 'title'
      if(sort_by_title === 'asc'){
        value = 'az'
      }
      if(sort_by_title === 'desc'){
        value = 'za'
      }
    }

    const found = options.find(opt => opt.key === key && opt.value === value)
    if (found) setDefaultValue({...found, label: found.label[language.name]})

  }, [query, options, language])

  const finalOptions = options.map(o => ({...o, label: o.label[language.name]}))

  return <>
    {
      (options && options.length > 0) &&
      <div className="flex">
        <p className="mr-1">{translation.SEARCH.sort_by[language.name]}:</p>
        <div className="relative pr-4 cursor-pointer">
          <Dropdown
            options={finalOptions}
            onChange={handleChange}
            value={defaultValue}
            className="sort-dropdown"
          />
          {/* <select
            className="appearance-none cursor-pointer bg-transparent mr-4 w-full"
            onChange={e => {e.persist(); handleChange(e)}}
            value={defaultValue}
          >
            {
              options.map((d, i) => (
                <option value={i} key={i}>
                  {d.label[language.name]}
                </option>
              ))
            }
          </select> */}
          <ChevronDown
            className="absolute right-0 top-0"
            style={{width: '16px'}}
          />
        </div>
      </div>
    }
  </>
}

Sorter.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array
}

Sorter.defaultProps = {
  onChange: (e) => {console.log(e)},
  options: []
}

export default Sorter
